var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-section" },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("i", { staticClass: "material-icons section-icon" }, [
          _vm._v("group"),
        ]),
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.section.audience.title"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "metric-row" },
        [
          _c("MetricCard", {
            attrs: {
              value: _vm.stats.page.page_fans || 0,
              "previous-value": _vm.prev("page_fans"),
              label: _vm.$t("dash.reporting.followers"),
              icon: "group",
            },
          }),
          _vm.network === "linkedin"
            ? [
                _vm.stats.page.organicFollowerGain != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.stats.page.organicFollowerGain || 0,
                        "previous-value": _vm.prev("organicFollowerGain"),
                        label: _vm.$t("dash.reporting.organicFollowerGain"),
                        icon: "person_add",
                      },
                    })
                  : _vm._e(),
                _vm.stats.page.paidFollowerGain != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.stats.page.paidFollowerGain || 0,
                        "previous-value": _vm.prev("paidFollowerGain"),
                        label: _vm.$t("dash.reporting.paidFollowerGain"),
                        icon: "paid",
                      },
                    })
                  : _vm._e(),
              ]
            : [
                _vm.sumFanAdds > 0
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.sumFanAdds,
                        "previous-value":
                          _vm.prev("page_fan_adds_unique") ||
                          _vm.prev("page_fan_adds"),
                        label: _vm.$t("dash.reporting.new_followers"),
                        icon: "person_add",
                      },
                    })
                  : _vm._e(),
                _vm.sumFanRemoves > 0
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.sumFanRemoves,
                        "previous-value":
                          _vm.prev("page_fan_removes_unique") ||
                          _vm.prev("page_fan_removes"),
                        label: _vm.$t("dash.reporting.nb_fans.lost_fans"),
                        icon: "remove_circle",
                      },
                    })
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm.activeGraphData.length && _vm.activeLabels.length
        ? [
            _c("div", { staticClass: "graph-title" }, [
              _vm._v(_vm._s(_vm.$t("dash.reporting.followers"))),
            ]),
            _c(
              "div",
              { staticClass: "graph-wrap" },
              [
                _c("Graph", {
                  attrs: {
                    id: `fans-combined-${_vm.graphId}`,
                    data: _vm.activeGraphData,
                    labels: _vm.activeLabels,
                    stacked: false,
                    height: "220px",
                    width: "100%",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }